import { render, staticRenderFns } from "./StoreDetail.vue?vue&type=template&id=5a4cf902&scoped=true&"
import script from "./StoreDetail.vue?vue&type=script&lang=js&"
export * from "./StoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoreDetail.vue?vue&type=style&index=0&id=5a4cf902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cf902",
  null
  
)

export default component.exports